import React, { FC } from 'react'
import { FlexibleHeroContainer } from './style'

//* Components
import Breadcrumbs from '../breadcrumbs'
import GlobalContainer from '../globalContainer'

//* Utils
import { ComponentFlexibleHero } from '../../../models/components/flexibleHero'
import { FlexibleHeroGrid } from './subcomponents'

type Props = {
  data: ComponentFlexibleHero
  showBreadcrumbs?: boolean
  locale?: string
  location?: any
  pageTitle?: string
  breadcrumb?: any
  pageType?: string
}

const FlexibleHero: FC<Props> = ({
  data,
  showBreadcrumbs = false,
  locale,
  location,
  pageTitle = '',
  breadcrumb,
  pageType,
}) => {
  if (!data) return null

  return (
    <FlexibleHeroContainer
      $backgroundUrl={data.backgroundImage?.image?.file?.url || ''}
      $backgroundTheme={data.theme}
      $useCase={data.useCase}>
      <GlobalContainer className="FlexibleHero__GlobalContainer">
        {showBreadcrumbs && (
          <div className="FlexibleHero__Breadcrumb">
            <Breadcrumbs
              backgroundTheme={data.theme.toLowerCase()}
              currentPathname={location?.pathname || '/'}
              pageName={pageTitle}
              pageType={pageType}
              locale={locale}
              breadcrumb={breadcrumb}
            />
          </div>
        )}

        <FlexibleHeroGrid data={data} showBreadcrumbs={showBreadcrumbs} />
      </GlobalContainer>
    </FlexibleHeroContainer>
  )
}

export default FlexibleHero
